import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

interface RoleGuardProps {
  allowedRole: 'Nông hộ' | 'Hợp tác xã';
  requireEkyc?: boolean;
  children: React.ReactNode;
}

export function RoleGuard({ allowedRole, requireEkyc = true, children }: RoleGuardProps) {
  const { user, isInitializing } = useAuth();

  // Session restore (silent refresh from the stored refresh token) is still in
  // flight — rendering a decision now would flash a login redirect for users who
  // are actually still authenticated.
  if (isInitializing) return null;

  if (!user) return <Navigate to="/dang-nhap" replace />;
  if (user.role !== allowedRole) return <Navigate to="/dang-nhap" replace />;

  // eKYC only ever applies to the farmer role — HTX staff review farmers' eKYC,
  // they don't have one of their own (previously this defaulted to `true` for every
  // HTX route too, which would have redirected every HTX user to /ekyc had the mock
  // data not coincidentally hardcoded kycStatus:'ekyc_verified' for every HTX demo account).
  if (requireEkyc && allowedRole === 'Nông hộ' && user.kycStatus !== 'ekyc_verified') return <Navigate to="/ekyc" replace />;

  return <>{children}</>;
}
